/* import __COLOCATED_TEMPLATE__ from './tue.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();